module.exports = __webpack_public_path__ + "static/media/service_breakfast-back.0f16fd6a.jpg";